export function estimateServerClockOffset(
  serverNow: number | undefined,
  observedLocalNow: number,
): number {
  return serverNow === undefined ? 0 : serverNow - observedLocalNow;
}

export function remainingTurnSeconds(
  deadlineAt: number | null,
  localNow: number,
  serverClockOffset: number,
): number | null {
  if (deadlineAt === null) return null;
  return Math.max(
    0,
    Math.ceil((deadlineAt - (localNow + serverClockOffset)) / 1000),
  );
}
